import React from 'react'

const BottomPagination = props => {
  const totalPages = Math.ceil(props.totalCount / props.perPage)

  const currentRange = () => {
    if (totalPages == 0) return '0 to 0'

    const firstItem  = props.page * props.perPage - props.perPage + 1
    const secondItem = props.page == totalPages ? props.totalCount : props.page * props.perPage

    return `${firstItem} to ${secondItem}`
  }

  const firstPage = () => props.page == 1 ? 1 : props.page - 1

  return (
    <div className='pagination'>
      <div className=''>
        Showing {currentRange()} of {props.totalCount} results
      </div>
      <div className='pagination-buttons'>
        <div
          className='page-button prev-page'
          onClick={ () => {
            if (props.page > 1) props.onPageChange(parseInt(props.page) - 1)
          }}>
          <i className='fc-icon fc-icon-chevron-left' />
        </div>
        <div className='page-buttons'>
          <div
            onClick={ () => props.onPageChange(firstPage()) }
            className={`page-button ${firstPage() == props.page ? 'active' :'' }`}>
              { firstPage() }
          </div>
          { firstPage() + 1 <= totalPages &&
            <div
              onClick={ () => props.onPageChange(firstPage() + 1) }
              className={`page-button ${firstPage() + 1 == props.page ? 'active' :'' }`}>
                { firstPage() + 1 }
            </div>
          }
          { firstPage() + 2 <= totalPages &&
            <div
              onClick={ () => props.onPageChange(firstPage() + 2) }
              className={`page-button ${firstPage() + 2 == props.page ? 'active' :'' }`}>
                { firstPage() + 2 }
            </div>
          }
        </div>
        <div
          className='page-button next-page'
          onClick={ () => {
            if (props.page < totalPages) props.onPageChange(parseInt(props.page) + 1)
          }}>
          <i className='fc-icon fc-icon-chevron-right' />
        </div>
      </div>
      <div />
    </div>
  )
}

export default BottomPagination
